import { postJson } from "./api"
import { devLog } from "./utils/devLog"

function extractSession(data) {
  const user =
    data?.user ??
    data?.data?.user ??
    (typeof data?.data === "object" && !Array.isArray(data.data) ? data.data : null) ??
    null

  let token = data?.token || data?.access_token || data?.data?.token
  if (!token && data?.authorization) token = data.authorization
  if (!token && typeof data === "string") token = data

  if (token) localStorage.setItem("auth_token", token)
  if (user) localStorage.setItem("auth_user", JSON.stringify(user))

  return { user, token, data }
}

/** Ask backend to send OTP via APITxT (authkey stays server-side). */
export async function sendOtp({ phone_number, purpose = "login" }) {
  const data = await postJson("otp/send", { phone_number, purpose })
  devLog("[sendOtp]", data)
  return data
}

/** Verify OTP and sign in existing user. */
export async function verifyOtpLogin({ phone_number, otp }) {
  const data = await postJson("otp/verify-login", { phone_number, otp })
  return extractSession(data)
}

/** Verify OTP and create account (passwordless). Name/email optional — user can update in profile later. */
export async function verifyOtpRegister({ phone_number, otp, name, email }) {
  const payload = {
    phone_number,
    otp,
    name: name?.trim() || `User ${String(phone_number).slice(-4)}`,
    role: "owner",
    username: email?.split("@")?.[0] || `user_${phone_number}`,
  }
  if (email?.trim()) payload.email = email.trim()
  const data = await postJson("otp/verify-register", payload)
  return extractSession(data)
}
